import { apiClient } from '../utils/api-client';

export interface FeatureFlagToggleResponse {
  name: string;
  enabled: boolean;
}

class FeatureFlagsService {
  private static instance: FeatureFlagsService;

  static getInstance(): FeatureFlagsService {
    if (!FeatureFlagsService.instance) {
      FeatureFlagsService.instance = new FeatureFlagsService();
    }
    return FeatureFlagsService.instance;
  }

  async toggleFlag(flagName: string, enabled: boolean): Promise<FeatureFlagToggleResponse> {
    const response = await apiClient.patch(`/api/feature_flags/${flagName}`, { enabled }, { requireAuth: true });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.errors?.[0]?.detail || `Failed to toggle flag: ${response.status}`);
    }

    const result = await response.json();
    return result.data.attributes as FeatureFlagToggleResponse;
  }
}

export const featureFlagsService = FeatureFlagsService.getInstance();
